<form [formGroup]="form">
  <div class="form-row">
    <!-- Date type -->
    <div class="col-auto" *ngIf="dateFields">
      <div class="input-group">
        <select
          class="form-control form-control-sm text-right"
          id="limit"
          formControlName="dateField"
          name="dateField"
        >
          <option *ngFor="let dateField of dateFields" value="{{ dateField }}">
            {{ 'list.filters.date-field.' + dateField | translate }}
          </option>
        </select>
      </div>
    </div>

    <!-- Date from -->
    <div class="col-auto ml-auto ml-sm-0" *ngIf="dateFields">
      <div class="input-group input-group-sm mb-2 mr-sm-2">
        <input
          type="text"
          class="form-control form-control-sm"
          id="dateFrom"
          formControlName="dateFrom"
          ngbDatepicker
          #d1="ngbDatepicker"
          autocomplete="chrome-off"
          placeholder="{{ 'list.filters.date.from' | translate }}"
        />
        <div class="input-group-append input-group-append-sm">
          <div class="input-group-text" (click)="d1.toggle()">
            <i class="fe fe-calendar"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- Date to -->
    <div class="col-auto ml-auto ml-sm-0" *ngIf="dateFields">
      <div class="input-group input-group-sm mb-2 mr-sm-2">
        <input
          type="text"
          class="form-control form-control-sm"
          id="dateTo"
          formControlName="dateTo"
          ngbDatepicker
          #d2="ngbDatepicker"
          autocomplete="chrome-off"
          placeholder="{{ 'list.filters.date.to' | translate }}"
        />
        <div class="input-group-append input-group-append-sm">
          <div class="input-group-text" (click)="d2.toggle()">
            <i class="fe fe-calendar"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Injected filters -->
    <ng-content></ng-content>

    <div class="col-sm-auto ml-sm-auto mt-3 mt-sm-0">
      <!-- Limit -->
      <div class="row">
        <div class="col-auto ml-sm-auto">
          <div class="input-group input-rounded">
            <label for="limit" class="mr-2 text-muted small my-1"
              >{{ 'list.filters.limit.label' | translate }}:</label
            >
            <select
              class="form-control form-control-sm text-right"
              id="limit"
              formControlName="limit"
              name="limit"
            >
              <option
                value="auto"
                *ngIf="!hideAutoLimit || form.controls.limit.value === 'auto'"
              >
                {{ 'list.filters.limit.auto' | translate }}
              </option>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>

        <div class="w-100 mt-2 d-none d-sm-block"></div>

        <div class="col-auto ml-auto">
          <!-- Refresh -->
          <button
            class="btn btn-sm btn-outline-secondary ml-2"
            type="button"
            (click)="onReset()"
          >
            {{ 'list.filters.reset-btn' | translate }}
          </button>
          <button
            class="btn btn-sm btn-outline-primary ml-2"
            type="button"
            (click)="onRefresh()"
            [disabled]="form.pristine"
          >
            {{ 'list.filters.confirm-btn' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
